import "./bootstrap-masonry.js";
import "./partials/desktop-search.js";
import $ from "jquery";
import "jquery-ui/ui/widgets/autocomplete";
import init from "./partials/desktop-search.js";

// KEEP THIS COMMENTED OUT UNTIL WE MERGE TO STAGING
// BECAUSE WE DON'T KNOW IF THIS WILL BREAK ANYTHING
// import "./select2.min.js";
// window.$ = $;
// window.jQuery = $;

// Initialize flatpickr
document.addEventListener("DOMContentLoaded", async () => {
  const modulesToLoad = document.querySelectorAll("[data-module]");
  // Restrict input to letters and numbers only
  $("#search-header-input").on("keypress", function (event) {
    const charCode = event.which || event.keyCode;
    const charStr = String.fromCharCode(charCode);

    // Allow only letters (a-z, A-Z) and numbers (0-9) and enter
    if (!/^[a-zA-Z0-9 ]+$/.test(charStr) && charCode !== 13) {
      event.preventDefault();
    }
  });
  $("#search-header-input")
    .autocomplete({
      source: function (request, response) {
        jQuery.ajax({
          headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
          },
          type: "POST",
          url: "/search/autocomplete",
          data: { term: request.term },
          success: function (data) {
            response(data.shows.slice(0, 15));
          },
          error: function () {
            swal({
              title: "<span style='color:red;'>Error!</span>",
              text: "There was an error trying to the autocomplete shows",
              html: true,
              type: "error",
            });
          },
        });
      },
      select: function (event, ui) {
        $("#search-header-input").val(ui.item.name);
        window.location.href = `/event/${ui.item.slug}`;
        return false;
      },
    })
    .autocomplete("instance")._renderItem = function (ul, item) {
    const price =
      !item.starting_at || item.starting_at == ""
        ? item.price
        : item.starting_at;
    const rawHTML = `
            <img src="${item.logo_url}" />   
            <div>
                ${item.name}
                <span>${item.category} | Price: <b>$${price}</b></span>
            </div>
        `;
    return $("<li>")
      .append("<div>" + rawHTML + "</div>")
      .appendTo(ul);
  };

  for (const el of modulesToLoad) {
    const moduleName = el.getAttribute("data-module");
    try {
      const module = await import(`./partials/${moduleName}.js`);
      module.default(); // call exported function
    } catch (error) {
      console.error(`Failed to load module: ${moduleName}`, error);
    }
  }
  init();
});
